export const columns = [
  {
    Header: "UserName",
    accessor: "userName",
    className: 'center',
  },
  {
    Header: "Full Name",
    accessor: "fullName",
    className: 'center',
  }
];
